import type { DummyFoods } from './dummyFoods'

export const pork: DummyFoods = {
  Pork: {
    Belly: {
      Cooked: ['Pork belly (cooked)'],
      Raw: ['Pork belly (raw)'],
    },
    Chops: {
      Cooked: ['Pork chops (cooked)'],
      Raw: ['Pork chops (raw)'],
    },
    Leg: {
      Cooked: ['Pork leg (cooked)'],
      Raw: ['Pork leg (raw)'],
    },
    Loin: {
      Cooked: ['Pork loin (cooked)'],
      Raw: ['Pork loin (raw)'],
    },
    Shoulder: {
      Cooked: ['Pork shoulder (cooked)'],
      Raw: ['Pork shoulder (raw)'],
    },
  },
}
